import { Box, VStack } from '@chakra-ui/react';
import { SearchSidebar } from '../components/SearchSidebar';
import { DeckImportSection } from '../features/card-print/DeckImportSection';
import { useCardPrint } from './card-print/useCardPrint';

export function CardPrintSidebarBound() {
  const { searchTerm, setSearchTerm, filters, setFilters } = useCardPrint();

  return (
    <VStack align="stretch" gap={4}>
      <Box css={{ '&:empty': { display: 'none' } }}>
        <DeckImportSection />
      </Box>
      <SearchSidebar
        filter={filters}
        setFilter={setFilters}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </VStack>
  );
}
